/** Intervals users can configure. One selected weekday repeats weekly. */
export const REMINDER_INTERVALS = ['daily', 'selected_days'] as const;

export type ReminderScheduleInterval = (typeof REMINDER_INTERVALS)[number];

/** Legacy rolling weekly schedules remain readable until explicitly replaced. */
export type ReminderInterval = ReminderScheduleInterval | 'weekly';
